var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.35;}\n\t.st1{fill:#06B6D4;}\n\t.st2{fill:#0284C7;stroke:#1D4ED8;stroke-width:1.269;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:#F86C66;stroke:#1D4ED8;stroke-width:1.269;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st5{fill:#FFFFFF;stroke:#1D4ED8;stroke-width:1.269;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st6{fill:#FED3BE;stroke:#1D4ED8;stroke-width:1.269;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st7{fill:none;stroke:#1D4ED8;stroke-width:1.269;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st8{fill:#9495FA;stroke:#1D4ED8;stroke-width:1.269;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st9{fill:#FDE68A;stroke:#1D4ED8;stroke-width:1.269;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st10{fill:none;stroke:#FDE68A;stroke-width:1.649;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st11{fill:none;stroke:#0284C7;stroke-width:1.649;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st12{fill:none;stroke:#1D4ED8;stroke-width:1.649;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st13{fill:none;stroke:#FF4B4D;stroke-width:1.222;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.1,22c4.2,10.6,1.4,24.5-8.2,31.2c-9.6,6.7-26,6.2-34.7-0.5S3.3,33.3,7.3,22.9c4-10.4,13.1-18.3,23.3-18.6 C40.7,3.9,51.8,11.3,56.1,22z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M13.3,16.3v20.3c0,1,0.8,1.8,1.9,1.8h20.8c0.6-4,3.6-7.2,7.6-8V16.2L13.3,16.3L13.3,16.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M14.8,17.9v17.3c0,0.9,0.7,1.5,1.7,1.5h20.1c1.8-2.7,1.9-4.3,5.2-5.7V17.9H14.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M13.3,16.3v-3.8c0-1,0.8-1.8,1.9-1.8h26.4c1.1,0,1.9,0.8,1.9,1.8v3.8H13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M20.2,13.5L20.2,13.5c-0.6,0-1.1-0.5-1.1-1.1V8.7c0-0.6,0.5-1.1,1.1-1.1l0,0c0.6,0,1.1,0.5,1.1,1.1v3.6 C21.3,13,20.8,13.5,20.2,13.5z M36.5,13.9L36.5,13.9c-0.6,0-1.1-0.5-1.1-1.1V9c0-0.6,0.5-1.1,1.1-1.1l0,0c0.6,0,1.1,0.5,1.1,1.1 v3.6C37.8,13.4,37.2,13.9,36.5,13.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M55.2,39.9c0,5.4-4.3,9.7-9.7,9.7s-9.7-4.3-9.7-9.7c0-0.5,0-1.1,0.1-1.6c0.6-4,3.6-7.2,7.6-8 c0.6-0.2,1.3-0.2,2-0.2C50.8,30.2,55.2,34.6,55.2,39.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M45.4,30.2V32 M35.7,39.9h1.9 M45.4,49.6v-1.9 M55.2,39.9h-1.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M46.7,39.9c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1 C46.2,38.7,46.7,39.3,46.7,39.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M49.2,39.9h-2.5 M44.7,39.1l-3.4-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M18,19.3h3.3v3.3H18V19.3z M26.7,19.3H30v3.3h-3.3V19.3z M35.4,19.3h3.3v3.3h-3.3V19.3z M18,25.6h3.3v3.3H18 V25.6z M26.7,25.6H30v3.3h-3.3V25.6z M35.4,25.6h3.3v3.3h-3.3V25.6z M18,31.8h3.3v3.3H18V31.8z M26.7,31.8H30v3.3h-3.3V31.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M9.2,9.2l1.7-1.7L12.3,9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M56.4,31.8l1.7-1.7l1.4,1.5 M6.7,15.6l-2.2,2.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M55.7,17.2l-2.6,2.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M23.9,47.4L21.3,50"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M55.3,54.7l-1.9,1.9"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.765775f04f362dc831e5790fd6d7367f.svg";
export { ForwardRef as ReactComponent };